import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("path", { d: "M16.845 13.572c-.208 1.715.636 2.64 1.58 4.715.904 1.962-.923 3.288-1.108 3.418l-.018.012A11.1 11.1 0 0 1 12.094 23a11.14 11.14 0 0 1-7.844-3.223A10.96 10.96 0 0 1 1 11.997 10.96 10.96 0 0 1 4.25 4.22C6.33 2.158 9.151 1 12.092 1a11.16 11.16 0 0 1 5.647 1.53 11.04 11.04 0 0 1 4.074 4.17v.003c1.319 4.41-4.766 5.153-4.968 6.868" }),
      _createElementVNode("path", { d: "M21.813 6.7v.003c1.319 4.409-4.766 5.151-4.968 6.867-.202 1.715.636 2.64 1.58 4.715.904 1.962-.923 3.288-1.108 3.418l-.018.012m-5.21-12.352c1.158 0 2.096-.93 2.096-2.078s-.938-2.079-2.096-2.079-2.095.93-2.095 2.079c0 1.148.938 2.078 2.095 2.078m-4.753 3.851a1.22 1.22 0 0 0 1.224-1.215 1.22 1.22 0 0 0-1.224-1.214 1.22 1.22 0 0 0-1.225 1.214c0 .671.548 1.215 1.225 1.215m1.742 4.208a.71.71 0 0 0 .713-.707c0-.391-.319-.708-.713-.708s-.713.317-.713.707c0 .391.32.708.713.708" })
    ], -1)
  ]))]))
}
export default { render: render }